import React, { useState, useEffect } from "react";
import {
  AiOutlineArrowRight,
  AiOutlineCamera,
  AiOutlineDelete,
} from "react-icons/ai";
import { MdTrackChanges } from "react-icons/md";
import { RxCross1 } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Country, State } from "country-state-city";
import { toast } from "react-toastify";
import axios from "axios";
import { server } from "../../server";
import {
  deleteUserAddress,
  loadUser,
  updatUserAddress,
  updateUserInformation,
} from "../../redux/actions/user";
import { getAllOrdersOfUser } from "../../redux/actions/order";
import UserAllOrders from "./UserAllOrders";
import AllRefundOrders from "./AllRefundOrders";
import ChangePassword from "./ChangePassword";
import UserAddress from "./UserAddress";
import UserProfileForm from "./UserProfileForm";
import UserInbox from "../../pages/UserInbox";
import UserSubscriptions from "../Subscription/UserSubscriptions";
import SubscriptionPricing from "../Subscription/SubscriptionPricing";


const ProfileContent = ({ active }) => {
  const { user, error, successMessage } = useSelector((state) => state.user);
  const [name, setName] = useState(user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [phoneNumber, setPhoneNumber] = useState(user?.phoneNumber || "");
  const [password, setPassword] = useState("");
  const [avatar, setAvatar] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch({ type: "clearErrors" });
    }
    if (successMessage) {
      toast.success(successMessage);
      dispatch({ type: "clearMessages" });
    }
  }, [error, successMessage]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(updateUserInformation(name, email, phoneNumber, password));
  };

  return (
    <div className="profile-content-component-container">
      {active === 1 && <UserProfileForm />}
      {active === 2 && <UserAllOrders />}
      {active === 3 && <AllRefundOrders/>}
      {active === 4 && <UserInbox embedded />}
      {active === 5 && <TrackOrder />}
      {active === 6 && <ChangePassword />}
      {active === 7 && <UserAddress />}
      {active === 9 && (
        <div className="profile-subscriptions-panel">
          <UserSubscriptions embedded />
          <section className="profile-subscriptions-plan-bento" aria-label="Subscription plans">
            <SubscriptionPricing />
          </section>
        </div>
      )}
    </div>
  );
};



const TrackOrder = () => {
  const { user } = useSelector((state) => state.user);
  const { orders } = useSelector((state) => state.order);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllOrdersOfUser(user._id));
  }, [dispatch, user._id]);

  return (
    <div className="profile-content-component-orders">
      {orders && orders.length > 0 ? (
        <table className="profile-content-component-table">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Status</th>
              <th>Items Qty</th>
              <th>Total</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
                <tr key={order._id}>
                  <td>{order._id}</td>
                  <td className={order.status === "Delivered" ? "greenColor" : "redColor"}>
                    {order.status}
                  </td>
                  <td>{order.cart.length}</td>
                  <td>{`US$ ${order.totalPrice}`}</td>
                  <td>
                    <Link to={`/user/track/order/${order._id}`}>
                      <button className="profile-content-component-view-btn" aria-label={`Track order ${order._id}`}>
                        <MdTrackChanges />
                      </button>
                    </Link>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      ) : (
        <div className="profile-settings-empty-state">
          <h3>No orders to track</h3>
          <p>Shipment updates will appear here as soon as an order is placed.</p>
          <Link to="/shops" className="profile-settings-empty-action">Browse Shops</Link>
        </div>
      )}
    </div>
  );
};


export default ProfileContent;

